'use strict';

module.exports = {

    animate: function animate() {
        var lines = document.getElementsByClassName('progress__bar-fill');

        //Animate Lines
        Array.prototype.forEach.call(lines, function(line) {
            line.style.width = line.dataset.percent + '%';
        });
    }
};



// WEBPACK FOOTER //
// ./resources/js/components/lineProgressBars.js